
/**
* Inspire-hub 2 (www.giap.pl)
*
* Copyright © GIAP sp.z.o.o. All rights reserved.
*
* Unauthorized copying of this file, via any medium is strictly prohibited
* Proprietary and confidential
* Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
*/
/* eslint-disable max-len */
import React from 'react';
import Layout from '../../../../components/Layout';
import ServicesLayout from '../../../../components/ServicesLayout';
import AddAvailableService from './AddAvailableService';

import { isAdminUser } from '../../../../lib/utils';

/* CHANGE THIS TITLE */
const title = 'Dodawanie dostępnych usług';

export default {

  path: '/available_services',
  async action(ctx) {
    const isAdmin = await isAdminUser(ctx);
    if (!isAdmin) {
      return { redirect: '/' };
    }
    return {
      title,
      chunk: 'AddAvailableService',
      component: <ServicesLayout isAdmin><AddAvailableService title={title} /></ServicesLayout>,
    };
  },
};



// WEBPACK FOOTER //
// src/routes/admin/available_services/add_availableservices/index.js